import React from "react";
import Layout from "../components/layout";
import { Flag, Award, Check } from "react-feather";

const Project = () => {
  return (
    <Layout>
      <div className="pt-4">
        <div className="border-gray-200 border-b">
          <div className="flex justify-center">
            <h1 className="text-2xl py-6 font-bold text-center uppercase">
              our mission
            </h1>
            <Flag className="h-24 w-8 self-center ml-4 fill-current text-sac-light_yellow pb-2" />
          </div>
          <div className="bg-white px-4 py-6 leading-loose sm:px-6 xl:px-16">
            <div className="max-w-6xl">
              <h1 className="text-xl pb-2 font-semibold">Background</h1>
              <div className="text-gray-700 text-lg">
                <div>
                  <h1 className="font-semibold text-gray-900">Problem</h1>
                  <h1>
                    Sacramento State accommodates over thirty thousand students,
                    thousands of employees, and countless visitors every
                    semester, for education, sports, and other events. How can
                    Sacramento State show its many users all of the events going
                    on?
                  </h1>
                </div>
                <div>
                  <h1 className="font-semibold text-gray-900">Question</h1>
                  <h1>
                    How can Sacramento State show it’s many users all of the
                    events going on?
                  </h1>
                </div>
                <div>
                  <h1 className="font-semibold text-gray-900">Details</h1>
                  <h1>
                    From boards to online calendars, there are several sources
                    for visitors to find out about Sac State events. No
                    consolidated, ubiquitous solution to know what Sac State has
                    happening, all the time. Events might be missing out on
                    attendees due to a lack of event knowledge among campus
                    residents and visitors.
                  </h1>
                </div>
                <div>
                  <h1 className="font-semibold text-gray-900">Solutions</h1>
                  <h1>
                    Centralize all available Sac State events, so that students
                    have the opportunity to experience the best that CSUS
                    offers.
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white px-4 py-6 leading-loose sm:px-6 xl:px-16 border-gray-200 border-b">
          <div className="max-w-6xl">
            <h1 className="text-xl pb-2 font-semibold">Scope</h1>
            <div className="text-gray-700 text-lg space-y-4">
              <div>
                <h1 className="font-semibold text-gray-900">
                  <Check className="inline-block mr-4 text-sac-light" />
                  Trumba Connected
                </h1>
                <h1>
                  The user can see all the available events pulled directly from
                  Trumba, Sacramento State’s Event Calendar service. Using
                  Trumba, this app should give the user the ability to view
                  events in one location, with added features.
                </h1>
              </div>
              <div>
                <h1 className="font-semibold text-gray-900">
                  <Check className="inline-block mr-4 text-sac-light" />
                  Simple Informative Views
                </h1>

                <h1>
                  An app to find out everything happening around users with an
                  easy-to-view and consistent user interface.
                </h1>
              </div>
              <div>
                <h1 className="font-semibold text-gray-900">
                  <Check className="inline-block mr-4 text-sac-light" />
                  Navigation Support
                </h1>
                <h1>
                  An app that helps users find their events at their physical
                  location (if the event is on campus) on a map and be guided to
                  their event's location using their camera.
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white px-4 py-6 leading-loose sm:px-6 xl:px-16 border-gray-200 border-b">
          <div className="max-w-6xl">
            <h1 className="text-xl pb-2 font-semibold">Proposed Solution</h1>
            <div className="text-gray-700 text-lg space-y-4">
              <div>
                <h1 className="font-semibold text-gray-900">
                  Develop a mobile application that centralizes Sac State event
                  information
                </h1>
                <h1>Show users events upcoming events</h1>
                <h1>A calendar to display events from the past and future</h1>
                <h1>Allow user to track real time events on a map</h1>
                <h1>
                  Utilize Augmented Reality (AR) to guide users to their desired
                  events
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white px-4 py-6 leading-loose sm:px-6 xl:px-16 border-gray-200 border-b">
          <div className="max-w-6xl">
            <h1 className="text-xl pb-2 font-semibold">Hightlights</h1>
            <div className="text-gray-700 text-lg space-y-4">
              <div>
                <h1 className="font-semibold text-gray-900">
                  One portal for all your event needs.
                </h1>
                <h1>
                  No more searching through multiple links and physical event
                  boards to get details about events on campus.
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white px-4 py-6 leading-loose sm:px-6 xl:px-16 border-gray-200 border-b">
          <div className="max-w-6xl">
            <h1 className="text-xl pb-2 font-semibold">Timeline</h1>
            <div className="text-gray-700 text-lg space-y-4">
              <div>
                <h1 className="font-semibold text-gray-900">Spring 2020</h1>
                <h1>Design and architect our app for Fall 2020.</h1>
                <h1 className="font-semibold text-gray-900">Fall 2020</h1>
                <h1>Execute and Deliver Product.</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="border-gray-200 border-b">
          <div className="bg-white py-8 px-4">
            <h1 className="text-center bold text-xl pb-4">Special thanks</h1>
            <div className="text-gray-700 text-lg text-center flex justify-center">
              <Award className="w-8 h-8 text-sac-dark_yellow" />
              <h1>
                Jonathan H. Bowman, Vice President & Chief Financial Officer
              </h1>
            </div>
            <div className="text-gray-700 text-lg text-center flex pt-4 justify-center">
              <Award className="w-8 h-8 text-sac-dark_yellow" />
              <h1>Margaret Hwang, Chief of Operations</h1>
            </div>
            <div className="text-gray-700 pt-4 text-lg text-center flex justify-center">
              <Award className="w-8 h-8 text-sac-dark_yellow" />
              <h1>
                Mark Konrad, Jeff Dillon, and Meng Her and more from the IRT
                Team
              </h1>
            </div>
            <div className="text-gray-700 pt-4 text-lg text-center flex justify-center">
              <Award className="w-8 h-8 text-sac-dark_yellow" />
              <h1>Karen Booth from the University of Communications</h1>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Project;
